// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AlertSeverity } from "./Shared.AlertSeverity.gen";
import { AlertChannel } from "./Shared.AlertChannel.gen";
import { AlertDigestMode } from "./Shared.AlertDigestMode.gen";

export interface IAlertSubscription {
	id: string | undefined;

	userId: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	minSeverity: AlertSeverity;

	channels: AlertChannel | number ;

	digestMode: AlertDigestMode;

	notifyOnAutoResolve: boolean;

	createdAtUtc: string | undefined;

	$type?: string | undefined;
}
export class AlertSubscription {
	constructor(data?: IAlertSubscription) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.createdAtUtc) { this.createdAtUtc = new Date(data.createdAtUtc); }
	}

	id: string | undefined;

	userId: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	minSeverity: AlertSeverity = 0;

	channels: AlertChannel | number  = 0;

	digestMode: AlertDigestMode = 0;

	notifyOnAutoResolve: boolean = false;

	createdAtUtc: Date | undefined = new Date();

	static $type: string = "CoreApi.Models.Alerts.AlertSubscription, ";
	$type?: string | undefined = AlertSubscription.$type;
}

